<template>
    <div class="select">
        <b-form-select :id="cid"
                       :value="value"
                       @change.native="$emit('input',  $event.target.value)"
                       :state="state"
                       :disabled="disabled"
                       :options="options"></b-form-select>
        <b-icon-chevron-down class="select__arrow" />
    </div>
</template>
<script>

export default {
    name: 'Select',
    props: {
        cid: String,
        value: String,
        options: Array,
        disabled: Boolean,
        state: Boolean
    },
};
</script>

<style lang="scss" scoped>
select {
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari and Chrome */
    appearance: none;
    background-image: none !important;
}
.select {
    position: relative;
    .select__arrow {
        pointer-events: none;
        position: absolute;
        font-size: 1.125rem;
        right: 20px;
        top: 10px;
    }
}
</style>
